"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formMetadataParamsPreprocessSchema = exports.formMetadataParamsFromDataModel = void 0;
var _zod = require("zod");
var _formMetadataParams = require("./formMetadataParams.schema");
/**
 * Preprocesses canonicalizer dataModel output before schema validation.
 * Canonicalizer returns "" for missing strings and null for missing enums,
 * but our schemas expect undefined for optional fields.
 */
const nullishToUndefined = v => v === "" || v === null ? undefined : v;
const formMetadataParamsPreprocessSchema = exports.formMetadataParamsPreprocessSchema = _zod.z.object({
  contentType: _zod.z.preprocess(nullishToUndefined, _formMetadataParams.contentTypeSchema.optional()),
  formId: _zod.z.preprocess(nullishToUndefined, _zod.z.string().optional()),
  modules: _zod.z.preprocess(nullishToUndefined, _zod.z.string().optional())
}).passthrough();
const formMetadataParamsFromDataModel = exports.formMetadataParamsFromDataModel = formMetadataParamsPreprocessSchema.pipe(_formMetadataParams.formMetadataParamsSchema);